module.exports = __webpack_public_path__ + "static/media/filter.c9c44045.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/filter.png
// module id = 280
// module chunks = 0